// src/app/interceptors/auth.interceptor.ts

import { inject } from '@angular/core';
import {
  HttpInterceptorFn,
  HttpRequest,
  HttpHandlerFn,
  HttpEvent,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { DataService } from '../utils/data.service';

export const authInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> => {
  const dataService = inject(DataService);
  const router = inject(Router);

  // ⚠️ Login sin token
  const publicRoutes = [
    '/login/agent',
    '/subpoena/add/evidence',
    '/pdf/generate',
  ];

  if (publicRoutes.some((route) => req.url.includes(route))) {
    return next(req);
  }

  const sessionData = dataService.getData('sessionData');

  if (!sessionData || !sessionData?.token) {
    dataService.deleteData('sessionData');
    router.navigateByUrl('');
    return throwError(() => new Error('No hay sesión activa.'));
  }

  const token = sessionData.token;
  const tokenExp = getTokenExpiration(token);

  if (tokenExp && tokenExp < Date.now() / 1000) {
    dataService.deleteData('sessionData');
    alert('Tu sesión ha expirado. Por favor inicia sesión nuevamente.');
    router.navigateByUrl('');
    return throwError(() => new Error('Token expirado.'));
  }

  const clonedRequest = req.clone({
    setHeaders: {
      Authorization: `Bearer ${token}`, // ✅ AQUÍ
    },
  });

  return next(clonedRequest).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401) {
        dataService.deleteData('sessionData');
        alert('No autorizado. Redirigiendo al login...');
        router.navigateByUrl('');
      }

      // 🔥 Forzar a preservar el error completo
      return throwError(
        () =>
          new HttpErrorResponse({
            error: error.error,
            headers: error.headers,
            status: error.status,
            statusText: error.statusText,
            url: error.url || undefined,
          }),
      );
    }),
  );
};

function getTokenExpiration(token: string): number | null {
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload.exp || null;
  } catch {
    return null;
  }
}
